import React, { useState, useEffect } from 'react';
import { assets } from '../assets/assets';

const Volunteer = () => {
  const [isIndividual, setIsIndividual] = useState(false);

  useEffect(() => {
    // Toggle visibility based on the 'isIndividual' state
    const toggleFields = () => {
      setIsIndividual(document.getElementById('individual').checked);
    };

    // Set initial state based on the selected radio button
    toggleFields();

    // Add event listener for changes to radio buttons
    const radioButtons = document.querySelectorAll('input[name="type"]');
    radioButtons.forEach((radio) =>
      radio.addEventListener('change', toggleFields)
    );

    // Cleanup event listeners on component unmount
    return () => {
      radioButtons.forEach((radio) =>
        radio.removeEventListener('change', toggleFields)
      );
    };
  }, []);

  return (
    <div>
      {/* Banner Section */}
      <div
        className="banner_sec request_campaign d-none d-md-flex"
        style={{ backgroundImage: `url(${assets.volunteer_banner})` }}
      >
        <div className="container">
          <div className="content">
            <h1 className="title text-uppercase text-white">Virtual Volunteering</h1>
            <p className="subtitle text-white">at Ihskas</p>
          </div>
        </div>
      </div>

      {/* Request Campaign Section */}
      <div className="request_campaing_sec">
        <div className="container">
          <div className="compaing_form">
            <form action="#" method="post">
              {/* Radio Buttons */}
              <div className="d-flex align-items-center mb-4">
                <div className="form-check me-2 me-sm-5">
                  <input
                    className="form-check-input"
                    type="radio"
                    value="ngo"
                    defaultChecked
                    name="type"
                    id="ngo"
                  />
                  <label className="form-check-label" htmlFor="ngo">
                    NGO
                  </label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    value="individual"
                    name="type"
                    id="individual"
                  />
                  <label className="form-check-label" htmlFor="individual">
                    Individual/Group
                  </label>
                </div>
              </div>

              {/* Form Fields */}
              <div className="row">
                <div className="col-md-6">
                  <div className="mb-4">
                    <label className="form-label">Your Name*</label>
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      required
                      placeholder="Enter full name"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-4">
                    <label className="form-label">Email id*</label>
                    <input
                      type="text"
                      name="email"
                      className="form-control"
                      required
                      placeholder="Enter Email id"
                    />
                  </div>
                </div>
                {/* Conditionally Rendered Fields */}
                {!isIndividual && (
                  <>
                    <div className="col-12 hideField">
                      <div className="mb-4">
                        <label className="form-label">NGO website Link (if any)</label>
                        <input
                          type="text"
                          name="website"
                          className="form-control"
                          required
                          placeholder="Website Link"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-4">
                        <label className="form-label">NGO Name*</label>
                        <input
                          type="text"
                          name="ngo_name"
                          className="form-control"
                          required
                          placeholder="NGO Name"
                        />
                      </div>
                    </div>
                    <div className="col-md-6 hideField">
                      <div className="mb-4">
                        <label className="form-label">Facebook Link*</label>
                        <input
                          type="text"
                          name="facebook"
                          className="form-control"
                          required
                          placeholder="Facebook Link"
                        />
                      </div>
                    </div>
                  </>
                )}
                <div className="col-md-6">
                  <div className="mb-4">
                    <label className="form-label">Location Of NGO*</label>
                    <input
                      type="text"
                      name="address"
                      className="form-control"
                      required
                      placeholder="Address"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-4">
                    <label className="form-label">Phone Number*</label>
                    <input
                      type="text"
                      name="phone"
                      className="form-control"
                      required
                      placeholder="Phone Number"
                    />
                  </div>
                </div>
                <div className="col-12">
                  <div className="mb-4">
                    <label className="form-label">Your Story (Why you started working on the NGO)*</label>
                    <textarea
                      name="textarea"
                      id="textarea"
                      className="form-control"
                      required
                      style={{ height: '152px' }}
                    ></textarea>
                  </div>
                </div>
              </div>

              {/* Notice Section */}
              <div className="notice p-4 mb-3">
                <p className="text-primary fw-bold mb-2">
                  Please help us understand your requirements by providing us with the following information: *
                </p>
                <ul>
                  <li>1. A brief story about how you started your NGO</li>
                  <li>2. What products do you require?</li>
                  <li>3. Who will be the beneficiary of these products and why do they need them?</li>
                </ul>
              </div>

              {/* Submit Button */}
              <div>
                <button type="submit" className="btn btn-primary shadow-none">
                  Submit
                  <img src="assets/images/icons/chevron-right.png" alt="right" />
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Volunteer;
